import { API } from "config";
import request from "utilities/request";

const baseUrl = API.cortevaChain.url;

export async function downloadFile(
  permalink: string,
  getAccessToken: () => Promise<string>
) {
  const accessToken = await getAccessToken();
  const headers = { Authorization: `Bearer ${accessToken}` };
  const response = await request(permalink, { method: "GET", headers });
  return await response.blob();
}

export async function downloadLegacyFile(
  fileName: string,
  activeChatId: string,
  getAccessToken: () => Promise<string>
) {
  const accessToken = await getAccessToken();
  const url = `${baseUrl}/chat/downloadfile/?thread_id=${activeChatId}&file_name=${fileName}`;
  const headers = { Authorization: `Bearer ${accessToken}` };
  const response = await request(url, { method: "GET", headers });
  return await response.blob();
}
